import React, { Component } from 'react';
import AuthService from '../services/auth';
import Api from '../services/api';
import './flirts.css';
import UserListEntry from '../components/UserListEntry';
import withAuthorization from '../components/withAuthorization';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import * as routes from '../constants/routes';

class Flirts extends Component {

  constructor(props) {
    super(props);
    this.state = {
      filter: {
        extra: ['favouritedBy'],
      },
      users: [],
    }
  }

  componentDidMount() {
    const { setCurrentPage } = this.props;
    if(!AuthService.isLoggedIn()) {
      this.props.history.push(routes.JOIN);
    } else {
      this.filterPosts();
      setCurrentPage(routes.FLIRTS);
    }
  }

  filterPosts() {
    const { filter } = this.state;
    (new Api()).get('/users', filter, AuthService.getAuthCookie())
      .then(response => {
        this.setState({
          users: response.users,
        });
      });
  }

  toggleTab(val) {
    this.setState({
      filter: {
        extra: [val],
      },
    }, () => {
      this.filterPosts();
    });
  }

  toggleFavourite(user, value) {
    if(value) {
      (new Api()).post('/favourites', {targetId: user}, AuthService.getAuthCookie())
        .then(() => {
          this.refreshCurrentUser();
        });
    } else {
      (new Api()).remove('/favourites', {targetId: user}, AuthService.getAuthCookie())
        .then(() => {
          this.refreshCurrentUser();
        });
    }
  }

  refreshCurrentUser() {
    const { authUser, onSetAuthUser } = this.props;
    (new Api()).get('/users/current', {}, AuthService.getAuthCookie())
      .then(response => {
        onSetAuthUser(authUser, response.user);
      });
  }

  render() {
    const { users, filter } = this.state;
    const { ucdUser } = this.props;
    return (
      <div className="container filters">
        <div className="row">
          <div className="col col-12 tabs">
            <div
              className={`tab ${(filter.extra.includes('favouritedBy')?'active':'')}`}
              onClick={() => {this.toggleTab('favouritedBy')}}
            >
              Received flirts
            </div>
            <div
              className={`tab ${(filter.extra.includes('favourited')?'active':'')}`}
              onClick={() => {this.toggleTab('favourited')}}
            >
             Sent flirts
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col col-12 list">
            <div className="row">
              <div className="col col-12 user">
                {users.map((user, i) => (
                    <UserListEntry
                      key={i}
                      user={user}
                      isFavourited={ucdUser.hasFavourited.includes(user.id)}
                      onFavourite={(user, value) => {this.toggleFavourite(user, value)}}
                      onClick={() => {this.props.history.push(`/member/${user.name}`)}}
                    />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  ucdUser: state.sessionState.ucdUser,
  authUser: state.sessionState.authUser,
});

const mapDispatchToProps = (dispatch) => ({
  onSetAuthUser: (authUser, ucdUser) => dispatch({ type: 'AUTH_USER_SET', authUser, ucdUser }),
  setCurrentPage: (page) => dispatch({ type: 'SET_CURRENT_PAGE', page }),
});

const authCondition = (authUser) => !!authUser;

export default compose(
  withAuthorization(authCondition),
  connect(mapStateToProps, mapDispatchToProps)
)(Flirts);


// WEBPACK FOOTER //
// ./src/pages/flirts.js